// English translations
const en = {
  // ===== Common =====
  '公共.保存': 'Save',
  '公共.取消': 'Cancel',
  '公共.删除': 'Delete',
  '公共.编辑': 'Edit',
  '公共.刷新': 'Refresh',
  '公共.确认': 'Confirm',
  '公共.加载中': 'Loading…',
  '公共.暂无数据': 'No data',
  '公共.操作': 'Actions',
  '公共.是': 'Yes',
  '公共.否': 'No',
  '公共.下一步': 'Next →',
  '公共.上一步': '← Back',
  '公共.复制': 'Copy',
  '公共.已复制': '✓ Copied',
  '公共.退出': 'Logout',
  '公共.请先输入Key': 'Please enter your API Key',
  '公共.格式错误': 'Format may be invalid',
  '公共.查询失败': 'Query failed',
  '公共.兑换': 'Redeem',
  '公共.立即兑换': 'Redeem now',
  '公共.兑换码': 'Redeem code',

  // ===== Navbar =====
  '导航.用户面板': 'User Panel',
  '导航.管理后台': 'Admin',
  '导航.接入指南': 'Integration Guide',
  '导航.公告': 'Notice',
  '导航.网关总览': 'Dashboard',
  '导航.渠道管理': 'Channels',
  '导航.令牌管理': 'Tokens',
  '导航.套餐管理': 'Plans',
  '导航.系统设置': 'Settings',
  '导航.修改密码': 'Change password',
  '导航.联系客服': 'Support',

  // ===== Home: 4 mini cards =====
  '首页.累计消耗': 'Total used',
  '首页.累计消耗说明': 'Used quota / Plan total (∞ for unlimited plans)',
  '首页.5小时消耗': '5h usage',
  '首页.5小时说明': 'Total quota (weighted by model rate) in the last 5 hours',
  '首页.本周消耗': 'Weekly usage',
  '首页.本周说明': 'Total quota (weighted by model rate) since Monday',
  '首页.网关状态': 'Gateway',
  '首页.无限': 'Unlimited',
  '首页.次': 'quota',
  '首页.在线': 'Online',
  '首页.离线': 'Offline',
  '首页.未知': 'Unknown',

  // ===== Home: API Key card =====
  '首页.我的APIKey': 'My API Key',
  '首页.请输入Key': 'Enter your API Key',
  '首页.Key提示': 'Paste a key starting with sk-. Format will be checked before query.',
  '首页.查询': 'Check balance',
  '首页.刷新': 'Refresh',
  '首页.清除': 'Clear',
  '首页.已选择': 'Selected',

  // ===== Home: Redeem =====
  '首页.兑换额度': 'Redeem quota',
  '首页.兑换码': 'Redeem code',
  '首页.兑换按钮': 'Redeem now',
  '首页.兑换说明': 'Enter a redeem code (usually starts with R-) to top up your account',

  // ===== Home: Integration sidebar =====
  '首页.接入说明': 'Integration',
  '首页.BaseURL': 'Base URL',
  '首页.默认模型': 'Default model',
  '首页.请求示例': 'Example request',
  '首页.复制成功': 'Copied',
  '首页.OpenAI兼容': 'OpenAI compatible',
  '首页.Anthropic兼容': 'Anthropic compatible',

  // ===== Logs / Chart =====
  '日志.ID': 'ID',
  '日志.时间': 'Time',
  '日志.模型': 'Model',
  '日志.次数': 'Quota',
  '日志.状态': 'Status',
  '日志.成功': 'OK',
  '日志.失败': 'Failed',
  '日志.已拦截': 'Blocked',
  '日志.请求日志': 'Request logs',
  '日志.恢复7天': 'Last 7 days',
  '日志.暂无日志': 'No logs',
  '日志.近7天': 'Last 7 days usage',
  '日志.无数据': 'No data in selected range',
  '图表.区间合计': 'Total',
  '图表.峰值': 'Peak',
  '图表.仅一天': 'Only one day has calls in this range',
  'key.天': 'd',
  'key.小时': 'h',
  'key.分钟': 'm',
  'key.创建时间': 'Created',
  'key.过期时间': 'Expires',
  'key.剩余': 'Remaining',
  'key.待激活': 'Pending',
  'key.永不过期': 'Never',
  'key.待激活说明': 'Pending (timer starts on first call)',

  // ===== Integration guide =====
  '指南.标题': 'Integration Guide',
  '指南.介绍': 'Set Base URL and API Key to start. No third-party relay.',
  '指南.BaseURL': 'Base URL',
  '指南.APIKey': 'API Key',
  '指南.OpenAI': 'OpenAI compatible',
  '指南.Anthropic': 'Anthropic compatible',
  '指南.Curl': 'cURL',
  '指南.OpenAI客户端': 'OpenAI-compatible client',
  '指南.Python': 'Python',
  '指南.Node': 'Node.js',
  '指南.复制': 'Copy',
  '指南.重要提示': '⚠️ Important',
  '指南.重要提示1': 'Use the config generated below to make sure the API points to this service (built-in presets in tools may differ and fail to connect)',
  '指南.重要提示2': 'Switching models updates the generated config in step 5',
  '指南.步骤1标题': 'Enter API Key',
  '指南.步骤1描述': 'Your key is the API key, format: sk-xxxxx',
  '指南.步骤2标题': 'Pick a tool',
  '指南.步骤2描述': 'Choose the tool you want to integrate with (the protocol each tool uses is shown below it)',
  '指南.步骤3标题': 'Pick an OS',
  '指南.步骤3描述': 'Match your development environment',
  '指南.步骤4标题': 'Pick a model',
  '指南.步骤4描述': 'Choose the model to use',
  '指南.步骤5标题': 'Generate config',
  '指南.步骤5描述': 'One click for a ready-to-use config',
  '指南.无模型': 'No models available yet. Configure a channel in the admin panel first.',
  '指南.粘贴提示': 'Paste the above into your tool config file',
  '指南.售后保障': 'After-sales',
  '指南.售后保障1': 'Models use official endpoints; speed and quality match the official service',
  '指南.售后保障2': 'If our service has issues, refund remaining quota',
  '指南.点击复制': 'Click to copy',
  '指南.也支持Bearer': 'Authorization: Bearer <YOUR_API_KEY> is accepted too',
  '指南.支持工具': 'Works with Claude Code, OpenCode, OpenClaw and more',
  '指南.查看指南': 'View integration guide →',
  '指南.步骤1详细': 'Your key is the API key, format:',
  '指南.步骤1占位符': 'Paste your API Key, e.g. sk-f47ac10b-...',
  '指南.推荐': 'Recommended',
  '指南.配置': 'Config',
  '指南.联系客服弹窗': 'Please contact our support for after-sales service',
  'guide.tool.ccswitch.badge': 'Recommended · One-click setup for Claude Code / OpenClaw / OpenCode',
  'guide.tool.claudecode.badge': 'Anthropic official coding assistant',
  'guide.tool.openclaw.badge': 'A do-it-all AI assistant',
  'guide.tool.opencode.badge': 'Open-source AI coding assistant',
  'guide.tool.curl.badge': 'Quick CLI test for the API',
  'guide.tool.openai.badge': 'Cherry Studio / Cursor / Python SDK and more',

  // ===== Admin: Tokens =====
  '令牌.页面标题': 'Tokens',
  '令牌.生成': '+ New Token',
  '令牌.导出': 'Export unsold CSV',
  '令牌.批量删除': 'Batch delete',
  '令牌.标记售出': 'Mark sold',
  '令牌.已选': '{n} selected',
  '令牌.全部状态': 'All status',
  '令牌.未售出': 'Unsold',
  '令牌.已售出': 'Sold',
  '令牌.全部套餐': 'All plans',
  '令牌.未关联套餐': 'No plan',
  '令牌.已下架': 'Off-shelf',
  '令牌.新键弹窗标题': 'Copy and save the new token now',
  '令牌.复制键提示': 'The full key is shown only once. You cannot retrieve it later.',
  '令牌.复制键按钮': 'Copy key',
  '令牌.生成成功': 'Generated and copied',
  '令牌.日志': 'Logs',
  '令牌.禁用': 'Disable',
  '令牌.启用': 'Enable',

  '令牌.状态.待售': 'For sale',
  '令牌.状态.待激活': 'Pending activation',
  '令牌.状态.使用中': 'Active',
  '令牌.状态.已禁用': 'Disabled',
  '令牌.状态.已过期': 'Expired',
  '令牌.状态.已耗尽': 'Depleted',
  '令牌.状态.未关联': 'No plan',
  '令牌.状态.套餐已删除': '(plan deleted)',

  // ===== Admin: Plans =====
  '套餐.页面标题': 'Plans',
  '套餐.新建': '+ New Plan',
  '套餐.名称': 'Name',
  '套餐.次数': 'Quota',
  '套餐.5h限额': '5h limit',
  '套餐.周限额': 'Weekly limit',
  '套餐.价格': 'Price',
  '套餐.启用': 'Enabled',

  // ===== Admin: 虚拟用户管理(历史遗留,已注释,保留注释以防意外引用) =====
  // '用户.页面标题': 'Users',
  // '用户.新建': '+ Add User',
  // '用户.用户名': 'Username',
  // '用户.密码': 'Password',
  // '用户.额度': 'Calls',
  // '用户.状态': 'Status',

  // ===== Admin: Channels =====
  '渠道.页面标题': 'Channels',
  '渠道.新建': '+ Add Channel',
  '渠道.名称': 'Name',
  '渠道.类型': 'Type',
  '渠道.BaseURL': 'Base URL',
  '渠道.支持模型': 'Models',
  '渠道.24h调用': '24h calls',

  // ===== Admin: Settings =====
  '设置.页面标题': 'Settings',
  '设置.Tab.基本设置': 'General',
  '设置.Tab.令牌默认值': 'Token defaults',
  '设置.Tab.对外发卡': 'Auto-delivery',
  '设置.Tab.补货策略': 'Replenishment',
  '设置.Tab.数据维护': 'Maintenance',
  '设置.站点名称': 'Site name',
  '设置.副标题': 'Tagline',
  '设置.公告': 'Announcement',
  '设置.对外地址': 'Public URL',
  '设置.保存设置': 'Save settings',

  // ===== Tickets (user side) =====
  '工单.按钮': 'Tickets',
  '工单.抽屉标题': 'My Tickets',
  '工单.提交按钮': 'New Ticket',
  '工单.空提示': 'No tickets yet. Tap above to submit one.',
  '工单.未读': '● Admin replied',
  '工单.未知状态': 'Unknown',
  '工单.消息条数': '{n} messages',
  '工单.提交弹窗标题': 'Submit a Ticket',
  '工单.提交成功': 'Ticket submitted. Our team will reply ASAP.',
  '工单.提交失败': 'Submit failed',
  '工单.主题': 'Subject',
  '工单.主题占位符': 'Briefly describe your issue',
  '工单.主题必填': 'Please enter a subject',
  '工单.内容': 'Details',
  '工单.内容占位符': 'Please describe your issue in detail',
  '工单.内容必填': 'Please describe the issue',
  '工单.详情标题': 'Ticket Details',
  '工单.发送': 'Send Reply',
  '工单.已关闭': 'This ticket is closed. No more replies can be added.',
  '工单.回复占位符': 'Type your reply…',
  '工单.回复必填': 'Please enter a reply',
  '工单.已回复': 'Reply sent',
  '工单.回复失败': 'Reply failed',
  '工单.创建于': 'Created at',
  '工单.作者用户': '👤 Me',
  '工单.作者管理员': '🛠 Admin',
  '工单.状态.进行中': 'Open',
  '工单.状态.已关闭': 'Closed',

  // ===== Language switcher =====
  '语言.中文': '中文',
  '语言.英文': 'English',
};

export default en;